angular.module('filters').filter('membershipPlanPaymentTypeFilter', function() {
  return function(membershipPlan) {
    switch (false) {
      case !(membershipPlan.cost_repeat > 0 && membershipPlan.type === 'recurring'):
        return 'Repeating payment';
      case !(membershipPlan.cost_upfront && membershipPlan.cost_upfront > 0):
        return 'Up-front payment';
      default:
        return 'No payment';
    }
  };
});
